import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=5167f20b&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5167f20b"]])

export default __exports__